const VERSAO = 1;
const DB_NAME = 'vitalize';

/**
 * Controlador para salvar e recuperar dados do IndexedDB
 */
class DatabaseController {
    /**
     * @type {IDBDatabase} Objeto de banco de dados criado
     */
    db = null;

    /**
     * Inicializa o acesso ao IndexedDB, deixando pronto para o uso
     * @returns {Promise}
     */
    init() {
        return new Promise((resolve, reject) => {
            //Caso o banco de dados já esteja preenchido, apenas retorna
            if (this.db) {
                resolve();
            } else {
                //Abre o banco de dados
                const request = window.indexedDB.open(DB_NAME, VERSAO);
    
                //Em caso de sucesso armazena a instância e resolve a Promise
                request.onsuccess = (event) => {
                    this.db = request.result;
                    resolve();
                }
    
                //Caso necessite de atualização cria as objectStores necessárias
                request.onupgradeneeded = (event) => {
                    if (event.oldVersion < 1) {
                        var db = event.target.result;
                        db.createObjectStore("config", { autoIncrement: false });
                    }
                }
                
                //Em caso de erro, rejeita a Promise com o código
                request.onerror = (event) => {
                    reject(event.target.errorCode);
                }
            }
        });
    }

    /**
     * Insere ou atualiza um valor no IndexedDB
     * @param {String} storeName Nome da objectStore ou tabela
     * @param {*} chave Chave do item a ser inserido ou atualizado
     * @param {*} valor Valor a ser inserido ou atualizado
     * @returns {Promise}
     */
    async salvar(storeName, chave, valor) {
        await this._validarRequisição(storeName, chave);
        
        //Salva o registro no banco
        return new Promise((resolve, reject) => this._salvar(resolve, reject, storeName, chave, valor));
    }

    /**
     * Lê um registro do IndexedDB. A promise é resolvida com o valor encontrado, ou `undefined` caso a chave não exista
     * @param {String} storeName Nome da objectStore ou tabela
     * @param {*} chave Chave do item a ser lido
     * @returns {Promise}
     */
    async carregar(storeName, chave) {
        await this._validarRequisição(storeName, chave);

        return new Promise((resolve, reject) => this._carregar(resolve, reject, storeName, chave));
    }

    /**
     * Valida os parâmetros de uma requisição e inicializa o banco de dados
     * @param {String} storeName Nome da objectStore a ser utilizada
     * @param {*} chave Chave do item a ser salvo ou obtido
     * @returns {Promise}
     */
    async _validarRequisição(storeName, chave) {
        //Verifica os parâmetros informados
        if (!storeName)
            throw TypeError('storeName é necessário');
        if (!chave)
            throw TypeError('Chave é necessária');

        //Inicializa o banco de dados
        await this.init();

        //Verifica se a store informada existe
        if (!this.db.objectStoreNames.contains(storeName))
            throw TypeError('Store não existe');
    }

    /**
     * Insere ou atualiza um valor no IndexedDB. Não deve ser chamado diretamente, chamar o método `salvar`
     * @param {Function} resolve Função a ser chamada quando a requisição for completada com sucesso
     * @param {Function} reject Função a ser chamada quando houver um erro na requisição
     * @param {String} storeName Nome da objectStore ou tabela
     * @param {*} chave Chave do item a ser inserido ou atualizado
     * @param {*} valor Valor a ser inserido ou atualizado
     */
    _salvar(resolve, reject, storeName, chave, valor) {
        const objectStore = this.db.transaction(storeName, 'readwrite').objectStore(storeName);
        const request = objectStore.put(valor, chave);

        request.onsuccess = () => {
            resolve();
        };

        request.onerror = (event) => {
            reject(event.target.errorCode);
        }
    }

    /**
     * 
     * @param {Function} resolve Função a ser chamada quando a requisição for completada com sucesso
     * @param {Function} reject Função a ser chamada quando houver um erro na requisição
     * @param {String} storeName Nome da objectStore ou tabela
     * @param {*} chave Chave do item a ser inserido ou atualizado
     */
    _carregar(resolve, reject, storeName, chave) {
        const objectStore = this.db.transaction(storeName, 'readonly').objectStore(storeName);
        const request = objectStore.get(chave);

        request.onsuccess = (event) => {
            resolve(event.target.result);
        }

        request.onerror = (event) => {
            reject(event.target.errorCode);
        }
    }
}

export default DatabaseController;